import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { selectInvoiceDetails } from "../../store/selectors/invoicing";
import { getAppUser, setCategories } from "../../store/actions/navigation";

import {
  getInvoiceDetails,
  storeInvoiceDetails,
} from "../../store/actions/invoicing";
import { MemoPanelComponent } from "../../components/invPreselPanel";

function InvoiceDetails() {
  const { invoice } = useParams();
  const invoiceDetails = useSelector(selectInvoiceDetails);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getAppUser());
    dispatch(storeInvoiceDetails([]));
    dispatch(setCategories("", "", ""));
  }, []);
  useEffect(() => {
    if (invoiceDetails.length < 1) {
      dispatch(getInvoiceDetails(invoice));
    }
  }, [dispatch, invoiceDetails, invoice]);
  let theInvoice = [];

  if (invoiceDetails.length > 0 && !invoiceDetails[0].collective_invoice) {
    theInvoice = invoiceDetails
      .map((invoice) => {
        return {
          invoiceNr: invoice.invoice_number,
          paid: invoice.paid,
          customer: invoice.customer,
          twinfield_id: invoice.twinfield_id,
          language: invoice.language,
          agent: invoice.agent,
          vatReverse: invoice.transfer_vat,
          subInvoices: [
            {
              id: invoice.id,
              description: invoice.description,
              invoiceLines: invoice.invoiceLines,
              transfer_vat: invoice.transfer_vat,
            },
          ],
          credited: invoiceDetails[0].credited,
        };
      })
      .sort(
        (a, b) =>
          a.subInvoices[0].description.split("\n")[3].split(" ")[2] -
          b.subInvoices[0].description.split("\n")[3].split(" ")[2],
      );
  } else if (invoiceDetails.length > 0) {
    let collectiveTwinFieldIds = [
      ...new Set(invoiceDetails.map((invoice) => invoice.twinfield_id)),
    ];
    for (let org of collectiveTwinFieldIds) {
      let orgInvoices = invoiceDetails.filter(
        (invoice) => invoice.twinfield_id === org,
      );

      let genDescBit = {
        "en-GB": {
          reverse: "Collective invoice with VAT reverse charged (BTW verlegd).",
          nonReverse: "Collective invoice.",
        },
        "nl-NL": {
          reverse: "Verzamelfactuur met BTW verlegd.",
          nonReverse: "Verzamelfactuur.",
        },
        "de-DE": {
          reverse:
            "Sammelrechnung mit Reverse-Charge-Mehrwertsteuer (BTW verlegd).",
          nonReverse: "Sammelrechnung.",
        },
      };

      theInvoice.push({
        invoiceNr: orgInvoices[0].invoice_number,
        paid: orgInvoices[0].paid,
        customer: orgInvoices[0].customer,
        agent: orgInvoices[0].agent,
        twinfield_id: orgInvoices[0].twinfield_id,
        language: orgInvoices[0].language,
        vatReverse: orgInvoices[0].transfer_vat,
        generalDesc: orgInvoices[0].transfer_vat
          ? genDescBit[orgInvoices[0].language].reverse
          : genDescBit[orgInvoices[0].language].nonReverse,
        subInvoices: orgInvoices
          .map((invoice) => {
            console.log("subinv2", invoice);
            return {
              id: invoice.id,
              description: invoice.description,
              invoiceLines: invoice.invoiceLines,
              transfer_vat: invoice.transfer_vat,
            };
          })
          .sort(
            (a, b) =>
              a.description.split("\n")[3].split(" ")[2] -
              b.description.split("\n")[3].split(" ")[2],
          ),
        credited: orgInvoices[0].credited,
      });
    }
    theInvoice.sort(
      (a, b) =>
        a.subInvoices[0].description.split("\n")[3].split(" ")[2] -
        b.subInvoices[0].description.split("\n")[3].split(" ")[2],
    );
  }
  return (
    <div className="invoicingBody">
      {/* {invoice +
        (theInvoice.length > 0
          ? theInvoice[0].credited
            ? " - Credited"
            : ""
          : "")} */}
      {theInvoice.length > 0 ? (
        <MemoPanelComponent
          paid={theInvoice[0].paid}
          descInvoiceNr={
            invoice +
            (theInvoice.length > 0
              ? theInvoice[0].credited
                ? " - Credited"
                : ""
              : "")
          }
          invoiceNr={theInvoice[0].invoiceNr}
          pastInvoice={true}
          customer={theInvoice[0].customer}
          twinfieldId={theInvoice[0].twinfield_id}
          generalDesc={theInvoice[0].generalDesc}
          subInvoices={theInvoice[0].subInvoices}
          language={theInvoice[0].language}
          agent={theInvoice[0].agent}
          vatReverse={theInvoice[0].vatReverse}
          theInvoiceLength={theInvoice.length}
          invIndex={0}
        />
      ) : (
        ""
      )}
    </div>
  );
}

export default InvoiceDetails;
